import { ART_STYLES, isArtStyle, type ArtStyleId } from "../../settings";
import { cartoon } from "./cartoon";
import { clay } from "./clay";
import { comic } from "./comic";
import { realistic } from "./realistic";
import { retro } from "./retro";
import type { ArtStyle } from "./types";

export { NEUTRAL_BUILD } from "./types";
export type { ArtStyle, DustLook, Surface, MaterialParams, PostChain, RiderBuild } from "./types";

// The art style registry (#75). A style id in settings without an entry here
// doesn't compile. Everything that builds meshes asks `activeStyle()`, so a
// switch is: set it, then rebuild the park, the rider and the lights.

export const STYLES: Readonly<Record<ArtStyleId, ArtStyle>> = { cartoon, realistic, retro, comic, clay };

let active: ArtStyle = cartoon;

export function activeStyle(): ArtStyle {
  return active;
}

export function setActiveStyle(id: ArtStyleId): ArtStyle {
  active = STYLES[id];
  return active;
}

/** Every style, in Settings order. */
export function allStyles(): ArtStyle[] {
  return ART_STYLES.map((id) => STYLES[id]);
}

/** `?style=realistic` in the page's URL picks a style (to share or bookmark a look). */
export function styleFromUrl(search: string): ArtStyleId | null {
  const v = new URLSearchParams(search).get("style");
  return isArtStyle(v) ? v : null;
}
